"use client";

import { MapPin, MessageCircle, Phone } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function GetInTouch() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="120386" id="lets-create-magic" className="relative overflow-hidden bg-background text-foreground py-24 sm:py-32">
      {}
      <div className="pointer-events-none absolute inset-0 flex items-center justify-center">
        <div className="h-[800px] w-[800px] rounded-full bg-[radial-gradient(circle_at_center,var(--color-primary)_0%,transparent_70%)] opacity-[0.06] blur-3xl" />
      </div>

      <div className="container relative z-10 mx-auto px-4">
        <div ref={ref} className={`mx-auto max-w-5xl transition-all duration-1000 ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-12 opacity-0"}`}>
          <div className="mb-16 grid gap-8 md:grid-cols-2">
            {}
            <Card className="group relative overflow-hidden border-none bg-primary text-primary-foreground shadow-xl">
              <div className="absolute -right-12 -top-12 h-48 w-48 rounded-full bg-white/10 blur-3xl transition-transform duration-700 group-hover:scale-150" />
              <CardContent className="relative z-10 flex h-full flex-col items-center justify-between gap-10 p-10 text-center sm:p-12">
                <div className="flex flex-col items-center space-y-6">
                  <div className="mb-2 flex h-20 w-20 items-center justify-center rounded-2xl bg-white/20 backdrop-blur-md">
                    <Phone className="h-10 w-10 text-primary-foreground" />
                  </div>
                  <h3 className="text-2xl font-semibold tracking-tight text-primary-foreground/90 font-sans">
                    Voice Inquiry
                  </h3>
                  <p className="text-4xl font-bold tracking-tighter sm:text-5xl font-sans">
                    +62 812 3456 7890
                  </p>
                </div>
                <Button variant="secondary" size="lg" className="h-14 w-full rounded-xl bg-background px-8 text-lg font-semibold text-primary hover:bg-background/90 sm:w-auto" asChild>
                  <Link to="tel:+6281234567890">Call Our Team</Link>
                </Button>
              </CardContent>
            </Card>

            {}
            <Card className="group relative overflow-hidden border-none bg-accent text-accent-foreground shadow-xl">
              <div className="absolute -right-12 -top-12 h-48 w-48 rounded-full bg-primary/10 blur-3xl transition-transform duration-700 group-hover:scale-150" />
              <CardContent className="relative z-10 flex h-full flex-col items-center justify-between gap-10 p-10 text-center sm:p-12">
                <div className="flex flex-col items-center space-y-6">
                  <div className="mb-2 flex h-20 w-20 items-center justify-center rounded-2xl bg-primary/10 backdrop-blur-md">
                    <MessageCircle className="h-10 w-10 text-primary" />
                  </div>
                  <h3 className="text-2xl font-semibold tracking-tight text-accent-foreground/80 font-sans">
                    WhatsApp Chat
                  </h3>
                  <p className="text-4xl font-bold tracking-tighter sm:text-5xl font-sans">
                    +62 812 3456 7890
                  </p>
                </div>
                <Button variant="default" size="lg" className="h-14 w-full rounded-xl bg-primary px-8 text-lg font-semibold text-primary-foreground hover:bg-primary/90 sm:w-auto" asChild>
                  <Link to="https://wa.me/6281234567890" newTab>
                    Check Availability
                  </Link>
                </Button>
              </CardContent>
            </Card>
          </div>

          {}
          <div className="mx-auto flex max-w-2xl flex-col items-center justify-center space-y-5 text-center">
            <div className="flex h-14 w-14 items-center justify-center rounded-full bg-muted">
              <MapPin className="h-6 w-6 text-primary" />
            </div>
            <div>
              <h4 className="mb-2 text-2xl font-bold text-foreground font-sans">
                UBUD EVENT SPACE
              </h4>
              <p className="text-lg text-muted-foreground font-sans">
                Jalan Raya Peliatan, Ubud, Gianyar, Bali – 80571
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}